<template>
  <header class="header">
    <div class="wrapper">
      <div class="left">
        <router-link to="/" class="logo">
          <img class="img" src="./../img/logo.svg" />
        </router-link>
        <div class="search">
          <img class="img" src="./../img/glass.svg" @click="searchSubmit()" />
          <input
            type="text"
            v-model="search"
            @keyup.enter="onEnter"
          />
        </div>
      </div>
      <div class="right">
        <div
          class="select-container currency-select-container language-select-container"
        >
          <Select2
            v-if="currencies.length > 1"
            class="select2 single currency-select"
            v-model="curr"
            @select="selectCurrency($event)"
            :options="currencies"
            :placeholder="curr"
          />
        </div>
        <ul class="nav">
          <template v-for="(item, i) in $parent.nav">
            <li class="nav__item" :key="i">
              <router-link :to="item.link">{{ item.title }}</router-link>
            </li>
          </template>
        </ul>
        <router-link
          to="/cart"
          v-if="$parent.isAuth"
          :class="['icon', { gray: !cartContents.length }]"
        >
          <img src="./../img/cart.svg" class="img" />
          <div class="indicator" v-if="cartContents.length"></div>
        </router-link>
        <div class="header-balance" v-if="$parent.isAuth">
          <router-link to="/profile" class="header-balance__amount">
            <PriceFormatter
              :price="formattedBalance"
              rootClass="header-balance__price"
            />
          </router-link>
          <button class="header-balance__add" @click="$emit('openTopUpModal')">
            +
          </button>
        </div>
        <router-link
          to="/profile"
          class="button link-container dropdown-open"
          v-if="$parent.isAuth"
        >
          <img src="./../img/user.svg" class="img" />
        </router-link>
        <div class="link-container" v-else>
          <div class="button modal-open" @click="openSignIn">
            <span>Sign In</span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Select2 from "vue3-select2-component";
import PriceFormatter from "./PriceFormatter.vue";

export default {
  name: "Header",
  props: ["cartContents", "searchedProductText", "userProfile"],
  components: {
    Select2,
    PriceFormatter,
  },
  data: function () {
    return {
      search: "",
    };
  },
  watch: {
    searchedProductText: function(newVal) {
      this.search = newVal;
    }
  },
  computed: {
    ...mapState("app", ["currencies", "currency"]),
    curr: {
      set(currency) {
        this.setCurrency(currency);
      },
      get() {
        return this.currency;
      },
    },
    formattedBalance() {
      const balance =
        this.userProfile && this.userProfile.balance !== undefined
          ? this.userProfile.balance
          : 0;
      return parseFloat(balance || 0).toFixed(2);
    },
  },
  methods: {
    searchSubmit() {
      this.$emit('searchSubmit', this.search)
    },
    onEnter() {
      this.searchSubmit();
    },
    selectCurrency(event) {
      this.setCurrency(event.id);
    },
    openSignIn() {
      this.$router.push({ path: "/login" });
    },
    openSignUp() {
      this.$router.push({ path: "/registration" });
    },
    openSaleSkinModal() {
      this.$emit("openSaleSkinModal");
    },
    logout() {
      this.$emit("logout");
    },
    ...mapMutations("app", ["setCurrentLanguage", "setCurrency"]),
  },
};
</script>

<style scoped>
.header-balance {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: 12px;
  color: #1e2329;
  font-size: 16px;
  line-height: 22px;
  white-space: nowrap;
}

.header-balance__amount {
  color: inherit;
  text-decoration: none;
}

.header-balance__price {
  color: #1e2329;
  font-weight: 700;
}

.header-balance__add {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #ff5f00;
  color: #fff;
  font-size: 22px;
  line-height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
}

.header-balance__add:hover {
  background: #ff7a2b;
}

@media screen and (max-width: 600px) {
  .header-balance {
    display: none;
  }
}
</style>
